import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { Loader2, Mail, Lock, ShieldCheck } from "lucide-react";
import Logo from "../components/Logo";

const AdminLogin = () => {
  const [email, setEmail] = useState("admin@dotmedy.local");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      localStorage.setItem("admin_token", res.data.token);
      nav("/admin/dashboard");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-2xl p-8">
        <div className="flex justify-center mb-4">
          <Logo size="lg" />
        </div>
        <div className="flex items-center justify-center gap-2 text-slate-700 mb-6">
          <ShieldCheck size={18} className="text-[#14B8A6]" />
          <span className="font-semibold uppercase tracking-wide text-sm">Admin Portal</span>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full pl-9 pr-3 py-2.5 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0F2A5F] text-sm" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full pl-9 pr-3 py-2.5 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0F2A5F] text-sm" />
            </div>
          </div>
          {err && <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2 rounded">{err}</div>}
          <button type="submit" disabled={busy} className="w-full bg-slate-900 hover:bg-slate-800 disabled:opacity-70 text-white font-semibold uppercase tracking-wide py-2.5 rounded-md flex items-center justify-center gap-2 transition-colors">
            {busy && <Loader2 size={16} className="animate-spin" />}
            Admin Sign in
          </button>
        </form>
        <div className="text-center mt-6">
          <Link to="/" className="text-sm text-slate-500 hover:text-slate-800">← Back to website</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
